<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item>
        <router-link to="/research/project"
          ><span>&#187;</span>科研项目</router-link
        >
      </b-nav-item>
      <b-nav-item>
        <router-link to="/research/publication"
          ><span>&#187;</span>科研成果</router-link
        >
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
